import { displayToast } from '../../components/Toaster/displayToast';
import apiFetch from '../apiFetch';
import generateHeaders from '../myHeaders';

const syncSurveyDatas = async (surveyId: number, initial: boolean, selectedSchema: string, successMessage: string, errorMessage: string): Promise<unknown> => {
    try {
        const result = await apiFetch(
            `${process.env.REACT_APP_API_URL}/synchronization/update_datas`,
            {
                method: 'POST',
                headers: generateHeaders(selectedSchema),
                body: JSON.stringify({ surveys_to_update: [surveyId], initial }),
            },
        );
        displayToast(successMessage, 'success');

        return result;
    } catch {
        displayToast(errorMessage, 'error');

        return undefined;
    }
};

export default syncSurveyDatas;
